import Liveness from "./Liveness";
import LoadScriptFilesService from "../LoadScriptFilesService";
const PATH = 'static/selfie/livenessSerasa/';

export default class LivenessSerasa extends Liveness{

    carregarArquivos(id) {
        let loadScript =  new LoadScriptFilesService();
        return loadScript.head_script(PATH+'brscan-sdk-selfie-liveness-serasa.min.js',id,'high');
    }

    preLoad() {
        const IMG_PERSOLANIZAVEL_1PX = PATH+'imagens-editadas/imagem1px.png';
        const IMG_PERSONALIZAVEL = PATH+'imagens-editadas/img-personalizavel.png';
        document.documentElement.style.setProperty('--cor-primary', '#660099');
        document.documentElement.style.setProperty('--font-family', 'VivoType');
        document.documentElement.style.setProperty('--cor-background-frame-captura', 'white');
        document.documentElement.style.setProperty('--cor-background-orientacoes', 'rgba(45, 53, 73, 1)');
        document.documentElement.style.setProperty('--seta-orientacoes', 'none');
        window.selfie = new window.SDK.Selfie(this.$store.state.chave);
        window.selfie.wizzard = false;
        window.selfie.desabilitaCapturaDesktop = true;
        window.selfie.playCaptureSound = false;
        window.selfie.imgOkIcone = IMG_PERSOLANIZAVEL_1PX;
        window.selfie.imgLiberar = IMG_PERSONALIZAVEL;
        window.selfie.imgLoading = IMG_PERSONALIZAVEL;
        window.selfie.imgLoadingFotografar = IMG_PERSONALIZAVEL;
        window.selfie.imgErrorDocumento = IMG_PERSONALIZAVEL;
        window.selfie.imgTelaModal = IMG_PERSONALIZAVEL;
        window.selfie.imgDicasRostoCentralizado = IMG_PERSONALIZAVEL;
        window.selfie.imgDicasAmbienteIluminado = IMG_PERSONALIZAVEL;
        window.selfie.imgDicasNaoAcessorios = IMG_PERSONALIZAVEL;
        window.selfie.imgDicasSigaAsIntrucoes = IMG_PERSONALIZAVEL;
        window.selfie.imgFecharIcone = IMG_PERSONALIZAVEL;
    }

    getRouteName() {
        return "LivenessSerasa";
    }
}



// WEBPACK FOOTER //
// ./src/services/liveness/LivenessSerasa.js